export enum enumChariotAlarmOperator {
    Off,
    EqualTo,
    NotEqualTo,
    LessThan,
    GreaterThan,
    LessThanOrEqual,
    GreaterThanOrEqual
}